<!-- 
@author Zou Tiancong
@version 0.0.1 20210429
@createDate 2021年4月29日
@updateDate 2022年11月10日
 -->
<template>
	<el-form ref="ruleForm"
		class="z-el-form"
		:model="formData"
		:label-position="formObj.labelPosition"
		:label-width="`${formObj.labelWidth|| 100}px`"
		:label-suffix="formObj.labelSuffix"
		:hide-required-asterisk="formObj.hideRequiredAsterisk"
		:show-message="formObj.showMessage"
		:inline-message="formObj.inlineMessage"
		:status-icon="formObj.statusIcon"
		:validate-on-rule-change="formObj.validateOnRuleChange"
		:size="formObj.size"
		:disabled="formObj.disabled">
		<el-row :gutter="20">
			<template v-for=" (formColumn,index) in formObj.formColumn">
				<el-col :key="index"
					v-show="!formColumn.notShow"
					:span="formColumn.width ? formColumn.width : 24">
					<el-form-item :label="formColumn.label+'：'"
						v-if="formColumn.type!='slot'"
						:prop="formColumn.prop"
						:rules="formColumn.notShow ? [] : formColumn.rules">

						<!-- inupt输入框 -->
						<el-input v-if="formColumn.type=='input'"
							v-model="formData[formColumn.prop]"
							:class="{'z-append':formColumn.highlight || false}"
							:maxlength="formColumn.maxlength"
							:show-word-limit="formColumn.showWordLimit"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请填写'+formColumn.label :'')"
							:clearable="formColumn.clearable"
							:show-password="formColumn.showPassword"
							:disabled="formColumn.disabled"
							:prefix-icon="formColumn.prefixIcon"
							:suffix-icon="formColumn.suffixIcon"
							@input="inputInput($event,index,formColumn.prop)"
							@change="inputChange($event,index,formColumn.prop)">
							<div v-if="formColumn.appendText"
								slot="append"
								@click="inputButtonClick(formData[formColumn.prop])">
								{{ formColumn.appendText }}
							</div>
						</el-input>

						<!-- textarea输入框 -->
						<el-input v-if="formColumn.type=='textarea'"
							v-model="formData[formColumn.prop]"
							type="textarea"
							:show-word-limit="formColumn.showWordLimit"
							:rows="formColumn.rows"
							:autosize="formColumn.autosize"
							:disabled="formColumn.disabled"
							:placeholder="formColumn.placeholder" />

						<!-- select选择器 -->
						<el-select v-if="formColumn.type=='select'"
							popper-class="select-dropdown"
							v-model="formData[formColumn.prop]"
							:multiple="formColumn.multiple"
							:disabled="formColumn.disabled"
							:value-key="formColumn.valueKey"
							:clearable="formColumn.clearable"
							:collapse-tags="formColumn.collapseTags"
							:multiple-limit="formColumn.multipleLimit"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')"
							:filterable="formColumn.filterable"
							:remote="formColumn.remote"
							:remote-method="(query)=>remoteMethod(query,index,formColumn)"
							:loading="searchSelectLoading"
							@change="selectChange($event,index,formColumn)"
							@focus="setOptionWidth">
							<el-option v-for="(options, sIndex) in formColumn.options"
								:style="{width:selectOptionWidth}"
								:key="sIndex"
								:label="formColumn.props ? options[formColumn.props.label] : options.label"
								:value="formColumn.props ? options[formColumn.props.value] : options.value" />
						</el-select>

						<!-- select树形选择器 -->
						<el-select ref="selectTree"
							v-if="formColumn.type=='selectTree'"
							v-model="formData[formColumn.prop]"
							:multiple="formColumn.multiple"
							:disabled="formColumn.disabled"
							:value-key="formColumn.valueKey"
							:clearable="formColumn.clearable"
							:collapse-tags="formColumn.collapseTags"
							:multiple-limit="formColumn.multipleLimit"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')"
							:filterable="formColumn.filterable"
							:remote="formColumn.remote"
							:remote-method="(query)=>remoteMethod(query,index,formColumn)"
							:loading="searchSelectLoading"
							@change="selectChange($event,index,formColumn)">
							<el-option class="select-tree"
								hidden
								v-for="(options, sIndex) in treeToArr(formColumn)"
								:key="sIndex"
								:label="formColumn.props ? options[formColumn.props.label] : options.label"
								:value="formColumn.props ? options[formColumn.props.value] : options.value">
							</el-option>
							<el-tree :data="formColumn.options"
								:props="formColumn.props"
								:lazy="formColumn.lazy"
								:load="treeLoadNode"
								@node-click="(data)=>selectTreeClick(data,formColumn.prop)">
							</el-tree>
						</el-select>

						<!-- 年月日时分秒选择器 -->
						<el-date-picker v-if="formColumn.type=='dateTime'"
							v-model="formData[formColumn.prop]"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetime"
							:disabled="formColumn.disabled"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')" />

						<!-- 年月日时分秒，开始和结束时间 -->
						<el-date-picker v-if="formColumn.type=='dateTimeRange'"
							v-model="formData[formColumn.prop]"
							value-format="yyyy-MM-dd HH:mm:ss"
							format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange"
							:disabled="formColumn.disabled"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" />

						<!-- 时分秒选择器 -->
						<el-time-picker v-if="formColumn.type=='timePicker'"
							v-model="formData[formColumn.prop]"
							value-format="HH:mm:ss"
							format="HH:mm:ss"
							:disabled="formColumn.disabled"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')"
							:picker-options="formColumn.options" />

						<!-- 时分秒选择器，开始和结束时间 -->
						<el-time-picker v-if="formColumn.type=='timePickerIsRange'"
							v-model="formData[formColumn.prop]"
							value-format="HH:mm:ss"
							format="HH:mm:ss"
							is-range
							:disabled="formColumn.disabled"
							range-separator="至"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							placeholder="选择时间范围" />

						<!-- 年月日选择器 -->
						<el-date-picker v-if="formColumn.type=='datePicker'"
							v-model="formData[formColumn.prop]"
							value-format="yyyy-MM-dd"
							:disabled="formColumn.disabled"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')" />

						<!-- 年月日选择器，开始和介绍年月日 -->
						<el-date-picker v-if="formColumn.type=='datePickerIsRange'"
							v-model="formData[formColumn.prop]"
							value-format="yyyy-MM-dd"
							type="daterange"
							:disabled="formColumn.disabled"
							:placeholder="formColumn.placeholder ||(formObj.showPlaceholder?'请选择'+formColumn.label :'')"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" />

						<!-- switch开关 -->
						<el-switch v-if="formColumn.type=='switch'"
							v-model="formData[formColumn.prop]"
							:disabled="formColumn.disabled"
							:active-icon-class="formColumn.activeIconClass"
							:inactive-icon-class="formColumn.inactiveIconClass"
							:active-text="formData[formColumn.prop] ? formColumn.activeText : ''"
							:inactive-text="!formData[formColumn.prop] ? formColumn.inactiveText : ''"
							:active-value="formColumn.activeValue"
							:inactive-value="formColumn.inactiveValue"
							:active-color="formColumn.activeColor"
							:inactive-color="formColumn.inactiveColor"
							:validate-event="formColumn.validateEvent"
							@change="formSwitchChange($event,index,formColumn.prop)" />

						<el-time-picker v-if="formColumn.type=='el-time-picker'"
							v-model="formData[formColumn.prop]"
							:readonly="formColumn.readonly"
							:disabled="formColumn.disabled"
							:editable="formColumn.editable"
							:clearable="formColumn.clearable"
							:placeholder="formColumn.placeholder || '请选择'"
							:start-placeholder="formColumn.startPlaceholder || '请选择'"
							:end-placeholder="formColumn.endPlaceholder || '请选择'"
							:is-range="formColumn.isRange"
							:arrow-control="formColumn.arrowControl"
							:align="formColumn.align"
							:popper-class="formColumn.popperClass"
							:picker-options="formColumn.pickerOptions"
							:range-separator="formColumn.rangeSeparator || '至'"
							:value-format="formColumn.valueFormat"
							:default-value="formColumn.defaultValue"
							:name="formColumn.name"
							:prefix-icon="formColumn.prefixIcon"
							:clear-icon="formColumn.clearIcon">
						</el-time-picker>

						<!-- radio单选框 -->
						<el-radio-group v-if="formColumn.type=='radio'"
							v-model="formData[formColumn.prop]"
							:disabled="formColumn.disabled">
							<el-radio v-for="(options, rIndex) in formColumn.options"
								:key="rIndex"
								:label="options.value">
								{{options.label}}
							</el-radio>
						</el-radio-group>

						<!-- checkbox复选框 -->
						<el-checkbox-group v-if="formColumn.type=='checkbox'"
							v-model="formData[formColumn.prop]"
							:disabled="formColumn.disabled">
							<el-checkbox v-for="options in formColumn.options"
								:key="options.value"
								:label="options.label" />
						</el-checkbox-group>

						<!--文件上传，如果对象有值就回显，没有值就为空 -->
						<el-upload v-if="formColumn.type=='upload'"
							:ref="formColumn.prop"
							:multiple="formColumn.uploadObj.multiple"
							:accept="formColumn.accept ? formColumn.accept : 'PNG,JPEG'"
							:file-list=" formData[formColumn.prop] ? formData[formColumn.prop] : []"
							:action="uploadUrl"
							:disabled="formColumn.disabled"
							:limit="formColumn.uploadObj.limit"
							:class="{'z-upload-hide':formColumn.uploadObj.hideUpload || formData[formColumn.prop].length==formColumn.uploadObj.limit}"
							:on-preview="handlePictureCardPreview"
							:on-remove="(file,fileList)=>handleRemove(file,fileList,formColumn.uploadObj.limit,formColumn.prop,index)"
							:on-success="(response,file,fileList)=>uploadSuccess(response,file,fileList,formColumn.uploadObj.limit,formColumn.prop,index)"
							list-type="picture-card"
							:auto-upload="true">
							<i slot="default"
								class="el-icon-plus" />
						</el-upload>
						<el-dialog v-if="formColumn.type=='upload'"
							:visible.sync="dialogVisible"
							:append-to-body="true"
							width="40%">
							<img width="100%"
								:src="dialogImageUrl"
								alt="">
						</el-dialog>

						<!-- 按钮 -->
						<el-button v-if="formColumn.type=='button'"
							:disabled="formColumn.disabled"
							:loading="formColumn.loading"
							:type="formColumn.buttonType || 'primary'"
							@click="buttonClick(formColumn.prop,index)">
							{{ formColumn.buttonObj.text }}
						</el-button>

						<!-- text展示 -->
						<span v-if="formColumn.type=='text'"
							v-text="formData[formColumn.prop]" />

						<!-- <quillEditor v-if="formColumn.editor"
							:quill="formData[formColumn.prop]"
							:disabled="disabled"></quillEditor> -->

					</el-form-item>
					<slot v-if="formColumn.type=='slot'"
						:name="formColumn.prop"
						:formColumn="formColumn" />
				</el-col>
			</template>
		</el-row>
	</el-form>
</template>
<!--  zoutiancong封装,date:20210429,详细使用见根目录@/views/home/testForm/testForm.vue,———————————————————————————————————————————————————————————————————————————————— -->
<script>
	// import quillEditor from '@/components/quillEditor/quillEditor.vue'
	export default {
		name: 'z-el-form',
		components: {
			// quillEditor
		},
		props: {
			formObj: {
				type: Object,
				required: true
			},
			formData: {
				type: Object,
				required: true
			},
		},
		data() {
			return {
				uploadUrl: this.$env.VUE_APP_BASE_UPLOAD_URL,
				dialogImageUrl: '',
				searchSelectLoading: false,
				dialogVisible: false,
				disabled: false,
				selectOptionWidth: 0,
			};
		},
		methods: {
			setOptionWidth(event) {
				this.$nextTick(() => {
					this.selectOptionWidth = event.srcElement.offsetWidth + "px";
				});
			},
			// 树转数组，用于selectTree回显
			treeToArr(formColumn) {
				// 有个奇怪的bug，form的其他组件变化也会进这里。为了减少内存消耗，首次进来就给他一个临时数组，如果临时数组存在就不再循环
				if (formColumn.tempArr) {
					return formColumn.tempArr
				} else {
					let {
						options,
						props,
						prop
					} = formColumn;
					const arr = [];
					const pushArr = (item => {
						const newTree = {
							[props.label || label]: item[props.label || label],
							[props.value || value]: item[props.value || value],
							[props.parentId || parentId]: item[props.parentId || parentId],
						};
						arr.push(newTree);
						if (item.children) {
							for (const item1 of item.children) {
								pushArr(item1);
							}
						}
					})
					for (const item of options) {
						pushArr(item);
					}
					if (arr.length > 0) {
						formColumn.tempArr = arr
					}
					return arr;
				}
			},

			// 树形下拉框点击
			selectTreeClick(data, prop) {
				this.formData[prop] = data[prop]
				this.$refs.selectTree[0].blur()

			},

			//select变化调用
			selectChange(value, index, formColumn) {
				this.$emit('selectChange', value, index, formColumn);
			},
			// input的input事件
			inputInput(value, index, prop) {
				this.$emit('inputInput', value, index, prop);
			},
			// input的change事件
			inputChange(value, index, prop) {
				this.$emit('inputChange', value, index, prop);
			},
			// input的按钮点击事件
			inputButtonClick(value) {
				this.$emit('inputButtonClick', value);
			},
			// 搜索类型select搜索
			remoteMethod(query, index, formColumn) {
				if (query) {
					this.searchSelectLoading = true;
					this.$emit('remoteMethod', query, index, formColumn);
					setTimeout(() => {
						this.searchSelectLoading = false;
					}, 500)
				} else {
					this.searchSelectOptios = [];
				}
			},
			//switch变化
			formSwitchChange(val, index, prop) {
				this.$emit("formSwitchChange", val, index, prop);
			},
			//按钮点击事件
			buttonClick(prop, index) {
				this.$emit("buttonClick", prop, index);
			},
			treeLoadNode(node, resolve, formColumn) {
				if (node.level !== 0) {
					this.$emit('treeLoadNode', node, resolve)
				}
			},
			//文件上传成功回调
			uploadSuccess(response, file, fileList, limit, prop, index) {
				if (response.code == 200) {
					fileList = fileList.map(item => {
						if (item.response) {
							return item.response.data
						}
						return item
					})
					this.pushUpload(file, fileList, limit, prop, index);
				} else {
					const errIndex = fileList.findIndex(item => item.uid == file.uid);
					if (errIndex != -1) {
						fileList.splice(errIndex, 1);
					}
					this.$message.error(response.msg)
				}
			},
			//文件删除
			handleRemove(file, fileList, limit, prop, index) {
				this.pushUpload(file, fileList, limit, prop, index);
			},
			// 文件预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},

			//提交时验证表单，直接在父级调用
			submitForm() {
				let formValidate = Boolean;
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						formValidate = true;
					} else {
						this.$message.warning("请完善信息！");
						formValidate = false;
					}
				});
				return formValidate;
			},
			/* 清空表单
				逻辑：
				1 、如果要清空文件上传列表，要传入要清空的upload的字段名，假如多个upload用for循环，调用清空方法！
				2、清空upload之后，还要把upload上传框展示出来，通过字段名比对，获取到在formObj中的下标，通过下标操作对象属性，进行展示
			*/
			resetForm(uploadArr) {
				this.$refs.ruleForm.resetFields();
				if (uploadArr) {
					for (let i = 0; i < uploadArr.length; i++) {
						this.$refs[uploadArr[i]][0].clearFiles();
						let index = this.formObj.formColumn.findIndex(item => item.prop == uploadArr[i]);
						this.formObj.formColumn[index].uploadObj.hideUpload = false;
					}
				}
			},
			// 单个字段验证
			validateFieldProp(prop) {
				let formValidate = Boolean;
				this.$refs.ruleForm.validateField(prop, valid => {
					if (!valid) {
						formValidate = true;
					} else {
						formValidate = false;
					}
				});
				return formValidate;
			},
			// 对文件上传，删除进行赋值，调用form验证
			pushUpload(file, fileList, limit, prop, index) {
				this.formObj.formColumn[index].uploadObj.hideUpload = fileList.length ==
					limit; //文件列表变化后判断当前文件列表长度是否等于限制长度。目的，当长度相等时隐藏文件上传按钮
				if (fileList.length > 0) {
					this.formData[prop] = fileList;
				} else {
					// 表示没有数据,把字段置空
					this.formData[prop] = "";
				}
				this.$refs.ruleForm.validateField(prop); //调用验证form表单的文件上传
			},
		}
	}
</script>

<style>
	.select-tree {
		height: 100%;
		padding: 0 !important;
	}
</style>
<style lang="scss"
	scoped>
	.select-dropdown {
		max-width: 100%;
	}

	.select-dropdown .el-select-dropdown__item {
		overflow: visible;
		display: block;
	}

	.z-el-form {
		$width: 100%;

		// 设置input框宽度
		::v-deep .el-input {
			width: $width;
		}

		// 设置选择框宽度
		::v-deep .el-select {
			width: $width;
		}

		// 设置时间选择框宽度
		::v-deep .el-range-editor.el-input__inner {
			width: $width;
		}

		// input框append高亮效果
		.z-append {
			::v-deep .el-input-group__append {
				background-color: #ecf5ff;
				color: #409eff
			}
		}

		// 设置文本框宽度
		.el-textarea {
			width: $width;
		}

		// 文件上传框，当达到限定的文件上传条数，隐藏上传框
		.z-upload-hide {
			::v-deep .el-upload--picture-card {
				display: none;
			}
		}

		::v-deep .el-row {
			display: flex; //设置布局
			flex-wrap: wrap; //进行换行操作
		}
	}
</style>